import { render, staticRenderFns } from "./exportSection.vue?vue&type=template&id=90e1b980&scoped=true"
import script from "./exportSection.vue?vue&type=script&lang=js"
export * from "./exportSection.vue?vue&type=script&lang=js"
import style0 from "./exportSection.vue?vue&type=style&index=0&id=90e1b980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e1b980",
  null
  
)

export default component.exports